module.exports = __webpack_public_path__ + "img/WATCH.96ca2186.webp";